<template>
  <div class="error-page">
    <div class="error-container">
      <div class="error-content">
        <h1>{{ $t('error.title') || 'Oops! Something went wrong' }}</h1>
        <p>{{ $t('error.message') || 'We encountered an error while loading the page.' }}</p>
        <div class="error-actions">
          <router-link to="/" class="btn btn-primary">
            {{ $t('error.go_home') || 'Go to Home' }}
          </router-link>
          <button @click="retryNavigation" class="btn btn-outline">
            {{ $t('error.try_again') || 'Try Again' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { logger } from '../utils/logger';

const router = useRouter();

const retryNavigation = () => {
  const lastAttemptedRoute = sessionStorage.getItem('lastAttemptedRoute') || '/';
  logger.debug('Retrying navigation to:', lastAttemptedRoute);
  router.push(lastAttemptedRoute);
};
</script>

<style scoped>
.error-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-xl);
  background-color: var(--bg-light);
}

.error-container {
  max-width: 600px;
  width: 100%;
  text-align: center;
  background-color: var(--bg-color);
  padding: var(--space-2xl);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
}

.error-content h1 {
  color: var(--text-color);
  margin-bottom: var(--space-lg);
}

.error-content p {
  color: var(--text-secondary);
  margin-bottom: var(--space-xl);
}

.error-actions {
  display: flex;
  gap: var(--space-md);
  justify-content: center;
}

@media (max-width: 480px) {
  .error-actions {
    flex-direction: column;
  }
  
  .error-container {
    padding: var(--space-xl);
  }
}
</style> 